import { callApi } from "./api";

export const createProduct = (data) => {
  const params = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    credentials: "include",
    method: "POST",
    body: "design_id=" + data.design_id + "&type=" + data.type,
  };

  let url = "create-product";
  return callApi(url, params).then((response) => {
    if (response.response) {
      return { response: response.response };
    } else {
      return { error: response.error };
    }
  });
};
